var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavyWaves(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgNavy",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f1d36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1f3a68"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgNavy)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.08,
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,150 C80,120 160,180 240,140 S400,150 400,150"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,170 C80,140 160,200 240,160 S400,170 400,170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,130 C80,100 160,160 240,120 S400,130 400,130"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavyWaves);
export default __webpack_public_path__ + "static/media/navy-waves.12b408bef742c219ec046dee49537a0b.svg";
export { ForwardRef as ReactComponent };